import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/public/PublicLayout';
import { PageHero } from './UniversitiesListPage';
import { Plus, Minus, HelpCircle } from 'lucide-react';

// Content seeded from the live EduBridge Network site.
const FAQS = [
  {
    q: 'Who is Edu Bridge Network?',
    a: "We're an online study abroad advisor. Our website, tools, and emails help you find and apply for the right program at the best university in one place. Plus, our expert advisors will give you guidance along the way.",
  },
  {
    q: 'How do you improve my chances of getting a university offer?',
    a: 'Our University Matchmaker filters programs by your eligibility (grades, English level, budget, degree type, country). We only recommend programs you genuinely qualify for, then our advisors review your documents before submission to maximise the chance of an offer.',
  },
  {
    q: 'When will I get an offer letter?',
    a: 'Most universities respond within 2 – 6 weeks of receiving a complete application. We track every submission and chase universities on your behalf so you always know where things stand.',
  },
  {
    q: 'Can I get a scholarship from you?',
    a: 'We maintain a live database of scholarships you may qualify for. After we shortlist your programs, we will share matching scholarships you can apply to alongside your university application.',
  },
  {
    q: 'Can you get me a Visa?',
    a: "We don't issue visas, but we guide you step-by-step through the visa process — preparing CAS letters, financial documents, sponsorship letters, and mock interviews. Final approval is at the discretion of the embassy.",
  },
];

const FAQPage = () => {
  const [open, setOpen] = useState(0);
  return (
    <PublicLayout>
      <PageHero title="Frequently Asked Questions" subtitle="Quick answers to the questions our students ask most." />

      <section className="max-w-3xl mx-auto px-4 py-12">
        <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-hidden" data-testid="faq-list">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`border-b last:border-b-0 border-gray-100`}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left flex items-center gap-3 px-6 py-5 hover:bg-gray-50 transition"
                  data-testid={`faq-toggle-${i}`}
                  aria-expanded={isOpen}
                >
                  <span className={`flex-1 font-semibold ${isOpen ? 'text-[#F5A623]' : 'text-[#1A2A4F]'}`}>{item.q}</span>
                  {isOpen ? <Minus className="w-4 h-4 text-[#F5A623] shrink-0" /> : <Plus className="w-4 h-4 text-[#1A2A4F] shrink-0" />}
                </button>
                {isOpen && (
                  <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-10 bg-gradient-to-br from-[#F5A623]/10 to-white border border-[#F5A623]/30 rounded-2xl p-7 flex items-start gap-4">
          <HelpCircle className="w-7 h-7 text-[#F5A623] shrink-0 mt-1" />
          <div className="flex-1">
            <h3 className="font-bold text-[#1A2A4F] text-lg">Still have a question?</h3>
            <p className="mt-1 text-sm text-gray-600">Our team usually replies within 24 hours.</p>
          </div>
          <Link to="/contact" className="bg-[#F5A623] text-white font-semibold px-5 py-2.5 rounded-md hover:brightness-95 transition shrink-0" data-testid="faq-contact-cta">
            Ask us
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
};

export default FAQPage;
